import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet'

export default function Login() {

  let [showpass, setShowPass] = useState(false);
  let [rot, setRot] = useState(false);

  let [userinfo, setUserinfo] = useState({
    email: "",
    password: ""
  });
  let [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setRot(true); // Show loading indicator
    setError(""); // Clear previous errors

    // Frontend validation
    if (!userinfo.email || !userinfo.password) {
      setError("All fields are required");
      setRot(false);
      return;
    }

    try {
      const response = await fetch('https://toolisobackend.vercel.app/loginUser', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: userinfo.email,
          password: userinfo.password
        })
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle HTTP errors (400, 500 etc)
        throw new Error(data.message || "Login failed");
      }

      if (data.success) {
        // Successful login
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));

        // Redirect to dashboard or home page
        setError("Logged in Successfully");
        setTimeout(() => {
          setError("");
          window.location.href = '/';
        }, 1500);
      } else {
        // Login failed (server returned success: false)
        setError(data.message || "Invalid credentials");
        setTimeout(() => {
          setError("")
        }, 2500);
      }
    } catch (error) {
      console.error("Login error:", error);
      setError(error.message || "An error occurred during login");
    } finally {
      setRot(false);
      // Auto-clear error after 3 seconds
      if (error) {
        setTimeout(() => setError(""), 3000);
      }
    }
  };

  return (
    <div className='signup'>
      <Helmet>
  <html lang="en" />
  <title>Tooliso Login – Access Premium Tools & Features</title>
  <meta
    name="description"
    content="Login to your Tooliso account to unlock premium features, advanced tools, and saved data. Secure and instant access to your dashboard."
  />
  <meta property="og:title" content="Tooliso Login – Get Access to Paid Tools" />
  <meta
    property="og:description"
    content="Sign in to Tooliso and access exclusive premium tools, custom solutions, and saved progress. Fast, secure, and simple login."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.tooliso.com/login" />
  <meta property="og:image" content="https://www.tooliso.com/login-og.jpg" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Tooliso Login – Secure Access to Premium Tools" />
  <meta
    name="twitter:description"
    content="Log in to Tooliso for instant access to all your tools and features. Premium utilities, saved data, and more await."
  />
  <meta name="twitter:image" content="https://www.tooliso.com/twitter-login.jpg" />
</Helmet>
      <div className="innersignup">
        <form className="secondsignup">
          <h1>Login</h1>

          <input
            name="email"
            placeholder='Email address'
            className='inputsignup'
            type="email"
            required
            value={userinfo.email}
            onChange={(e) => setUserinfo({ ...userinfo, email: e.target.value })}
          />

          <div className="thirdsignup">
            <input
              name="password"
              placeholder='Password'
              className='inputsignup'
              type={showpass ? 'text' : 'password'}
              required
              value={userinfo.password}
              onChange={(e) => setUserinfo({ ...userinfo, password: e.target.value })}
            />
            {
              showpass ?
                <p onClick={() => setShowPass(false)} className='eyecheck'>🔒</p> :
                <p onClick={() => setShowPass(true)} className='eyecheck'>👁️</p>
            }


          </div>

          <div style={{ margin: '15px 0', textAlign: 'right' }}>
            <Link to="/forgot-password" style={{ color: '#888', fontSize: '14px' }}>
              Forgot password?
            </Link>
          </div>
          {
            rot ?
              <button className='btn1signup'>
                <div className="spinner"></div>
              </button>
              :
              <button className='btn1signup' type="submit" onClick={handleSubmit}>
                <p style={{ color: "black" }}>Login</p>
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
          }
          <p style={{ color: 'red' }}>{error}</p>
          <div className="linesignup">
            <div></div>
            <p>or</p>
            <div></div>
          </div>

          <p style={{ textAlign: 'center', marginTop: '20px' }}>
            Don't have an account?{' '}
            <Link to="/signup">
              Sign up
            </Link>
          </p>
        </form>
      </div>
    </div>
  )
}
